"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "colorrequestListCtrl",
    function (
      $scope,
      $rootScope,
      $filter,
      permissionService,
      settings,
      apiSettings,
      MessageService,
      FileSaver,
      ColorRequest,
      Reports,
      status,
      states,
      managers,
      $stateParams,
      $sessionStorage,
      enumerators
    ) {
      var vm = this;
      vm.settings = settings;
      vm.initialized = false;
      vm.isRefreshing = false;

      var $translate = $filter("translate");

      vm.permissions = permissionService;
      vm.status = status;
      vm.states = states;
      vm.managers = managers;
      vm.groups = window.enumerators.enumGroupsColorsRequests;
      vm.enumerators = enumerators;
      vm.currentPage = 0;

      vm.isControleQualidade = function () {
        return vm.settings.isColorsUserGroupByName('ControleQualidade');
      };

      angular.extend($scope.$parent.vm, {
        title: "colorsRequests.settings.title",
        insertUrl: vm.permissions.isAuthorized("InsertColorsRequests")
          ? "main.colorrequest-edit"
          : null,

      });

      $rootScope.laddaLoading = false;

      $scope.$watch("vm.pagination.currentPage", function (newValue, oldValue) {
        if (vm.pagination && vm.pagination.currentPage && newValue !== oldValue && newValue !== vm.currentPage) {
          vm.refresh(newValue);
        }
      });

      vm.refresh = function (page, filter) {
        if (!vm.isRefreshing) {
          vm.isRefreshing = true;

          var _filter = filter || $sessionStorage.colorsRequestsContextFilter;
          var filterCustomer = $sessionStorage.colorsRequestsContextFilter_Customer || null;


          if (!_filter) {
            var todayDate = new Date(Date.now());
            var _365DaysAgo = new Date(todayDate.getTime() - (365 * 24 * 60 * 60 * 1000));
            _filter = {
              startsOn: _365DaysAgo,
              endsOn: todayDate,
              expired: false,
            };
          }

          _filter.page = page || _filter.page || 1;
          _filter.customerId = null;
          if (filterCustomer) _filter.customerId = filterCustomer.key;

          $sessionStorage.colorsRequestsContextFilter = _filter;

          ColorRequest.list(_filter).$promise.then(function (data) {

            if (!vm.pagination) {
              vm.currentPage = page;
              vm.pagination = {
                list: data,
                currentPage: data.page,
                pageSize: apiSettings.defaultPageSize,
                pagesTotal: data.total
              };
            } else {
              vm.currentPage = page;
              vm.pagination.list = data;
              vm.pagination.currentPage = page;
              vm.pagination.pagesTotal = data.total;
            }
          }).finally(function () {
            vm.isRefreshing = false;
            vm.initialized = true;
          });
        }
      };

      // Caso tenha projeto com mais de 60 dias para loja retorna para projetos vencidos
      if ($stateParams.expired) {
        vm.filter.expired = true;
        vm.refresh(1);
      }

      vm.showDeleteButton = function (currentStatusId) {
        // Só Solicitante ou Controle de Qualidade pode deletar nos Status de Aguard. Init Prod ou Em Espera
        if (
          settings.permissions.includes("DeleteEditColorRequest") &&
          (currentStatusId == vm.enumerators.statusColor.EmEspera ||
            currentStatusId ==
            vm.enumerators.statusColor.AguardandoIniciodeProducao)
        ) {
          return true;
        }
        return false;
      };

      vm.delete = function (colorsRequestId) {
        MessageService.confirmDelete(function () {
          ColorRequest.deleteColor(
            { colorsRequestId: colorsRequestId },
            function () {
              vm.refresh(1);
            },
            function (response) {
              MessageService.alertError(response.data);
            }
          );
        });
      };

      vm.updateFilters = function (filter) {
        vm.refresh(1, filter);
      };
    }
  );
